import request from '@/utils/request'
// 查询状态列表
export function qryStatusInfo(query) {
  if (query.modelName) {
    return request({
      url: '/api/base/qryStatusInfo',
      method: 'get',
      params: {
        pageIndex: query.pageIndex,
        pageSize: query.pageSize,
        modelName: query.modelName
      }
    })
  } else {
    return request({
      url: '/api/base/qryStatusInfo',
      method: 'get',
      params: {
        pageIndex: query.pageIndex,
        pageSize: query.pageSize
      }
    })
  }
}
// 添加状态列表
export function addStatusInfo(query) {
  return request({
    url: '/api/base/addStatusInfo',
    method: 'post',
    data: query
  })
}
// 修改状态列表
export function modStatusInfo(query) {
  return request({
    url: '/api/base/modStatusInfo',
    method: 'post',
    data: query
  })
}
// 删除状态列表
export function delStatusInfo(query) {
  return request({
    url: '/api/base/delStatusInfo',
    method: 'post',
    data: {
      Id: query.SId
    }
  })
}
// 查询应用列表
export function qryProgramInfo(query) {
  return request({
    url: '/api/base/qryProgramInfo',
    method: 'get',
    params: {
      pageIndex: query.pageIndex,
      pageSize: query.pageSize
    }
  })
}
// 添加应用列表
export function addProgramInfo(query) {
  return request({
    url: '/api/base/addProgramInfo',
    method: 'post',
    data: query
  })
}
// 修改应用列表
export function modProgramInfo(query) {
  return request({
    url: '/api/base/modProgramInfo',
    method: 'post',
    data: query
  })
}
// 删除应用列表
export function delProgramInfo(query) {
  return request({
    url: '/api/base/delProgramInfo',
    method: 'post',
    data: {
      Id: query.PgId
    }
  })
}
// 查询角色列表
export function qryRoleInfo(query) {
  if (query && query.rId) {
    return request({
      url: '/api/base/qryRoleInfo',
      method: 'get',
      params: {
        rId: query.rId
      }
    })
  } else {
    return request({
      url: '/api/base/qryRoleInfo',
      method: 'get',
      params: query
    })
  }
}
// 添加角色
export function addRoleInfo(query) {
  return request({
    url: '/api/base/addRoleInfo',
    method: 'post',
    data: query
  })
}
// 修改角色
export function modRoleInfo(query) {
  return request({
    url: '/api/base/modRoleInfo',
    method: 'post',
    data: query
  })
}
// 删除角色
export function delRoleInfo(query) {
  return request({
    url: '/api/base/delRoleInfo',
    method: 'post',
    data: {
      Id: query.RoleId
    }
  })
}
// 查询用户账户信息
export function qryUserAccountInfo(query) {
  return request({
    url: '/api/base/qryUserAccountInfo',
    method: 'get',
    params: query
  })
}
// 查询用户菜单
export function qryUserRoleProgramInfo(query) {
  return request({
    url: '/api/user/qryUserRoleProgramInfo',
    method: 'get',
    params: query
  })
}
